import { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';

const useAthenaViewDetails = () => {
	const [showLoader, setShowLoader] = useState(false);
	const history = useHistory();
	const location = useLocation();
	const rowData = _get(location, ['state', 'rowData']);

	const handleFormCancel = () => {
		history.goBack();
	};

	// Transform the data to include formatted status and dates
	const data = rowData
		? {
				...rowData,
				defaultQueryParams:
					typeof rowData.defaultQueryParams === 'string'
						? rowData.defaultQueryParams
						: JSON.stringify(rowData.defaultQueryParams, null, 2)
		  }
		: {};

	return { showLoader, setShowLoader, handleFormCancel, data };
};

export default useAthenaViewDetails;
